export class GMResolutionsPutCloseRequest {
  resolutionId: string
  version: number

  constructor(resolutionId: string, version: number) {
    this.resolutionId = resolutionId
    this.version = version
  }
}
